import { useExperiment } from '@moonpig/web-core-eppo/browser'
import React, { FC } from 'react'
import { DepartmentsEnum } from '@moonpig/web-explore-types-graphql'
import { FiltersCarouselStickyWrapper } from '../FiltersCarousel/components'
import { QuickFilters } from '../QuickFilters/QuickFilters'
import { FiltersCarousel } from '../FiltersCarousel'

type FiltersBarProps = {
  departments: DepartmentsEnum[]
}

export const FiltersBar: FC<FiltersBarProps> = ({ departments }) => {
  const isQuickFiltersV3Enabled =
    useExperiment('search-quick-filters-dropdowns-v3', {
      fallback: 'disabled',
    })?.toLowerCase() === 'enabled'

  return isQuickFiltersV3Enabled ? (
    <>
      <FiltersCarouselStickyWrapper>
        <QuickFilters departments={departments} />
      </FiltersCarouselStickyWrapper>
      <FiltersCarousel shouldBeSticky={false} />
    </>
  ) : (
    <>
      <QuickFilters departments={departments} />
      <FiltersCarousel />
    </>
  )
}
